import React from "react";
import "./TermsConditions.css";

function TermsConditions() {
  return (
    <div className="pattern-bg2">
      <div className="container a-container pt-[35px] pb-[35px] ">
        <h1 className="heading">User Agreement</h1>
        <div className="line-div4 "></div>
        <p className="paragraph pb-[15px] ">
          By accessing the <strong>.gold Marketplace</strong>, you agree to
          comply with all terms outlined herein. Engaging in any prohibited
          activities may result in account suspension or termination.
          <br />
          Our user agreement aims to foster a fair, transparent, and trustworthy
          marketplace environment. Users must adhere to ethical conduct,
          refraining from any fraudulent, misleading, or malicious activity. We
          reserve the right to investigate and take necessary actions against
          violations to protect the integrity of our community.
        </p>

        <h1 className="heading">Account Responsibility</h1>
        <div className="line-div4 "></div>
        <p className="paragraph pb-[15px]">
          Users are responsible for maintaining the confidentiality of their
          account credentials and ensuring secure access to their accounts. Any
          unauthorized access or misuse must be reported immediately.
          <br />
          We prioritize the security of your data and employ industry-standard
          protection measures. Users must keep their profile and payment details
          accurate and up to date for smooth transactions and domain ownership
          transfers. Cooperation in verification requests helps ensure the
          safety of all marketplace participants.
        </p>

        <h1 className="heading">Transaction Guidelines</h1>
        <div className="line-div4 "></div>
        <p className="paragraph pb-[15px]">
          Engaging in domain transactions on the{" "}
          <strong>.gold Marketplace</strong> implies adherence to fair
          purchasing and selling practices. Buyers and sellers are expected to
          act in good faith, avoiding any form of manipulation, false
          representation, or interference.
          <br />
          Our platform is committed to providing equal opportunities for all
          registered users. Any attempt to misrepresent listings, manipulate
          pricing, or mislead potential buyers is strictly prohibited. We
          encourage honest communication and transparent dealings to maintain a
          credible and reliable marketplace for everyone.
        </p>

        <h1 className="heading">Listing Policies</h1>
        <div className="line-div4 "></div>
        <p className="paragraph pb-[15px]">
          Sellers must ensure that all domain listings are accurate, available
          for transfer, and free from legal disputes. Misleading descriptions,
          inflated claims, or fraudulent ownership representation will lead to
          account review or termination.
          <br />
          The <strong>.gold Marketplace</strong> reserves the right to edit,
          suspend, or remove any listing that violates platform guidelines,
          ethical standards, or intellectual property rights. Repeated
          violations may lead to permanent account restrictions.
        </p>

        <h1 className="heading">Intellectual Property</h1>
        <div className="line-div4 "></div>
        <p className="paragraph pb-[15px]">
          Respecting intellectual property rights is a cornerstone of our
          marketplace. Users are strictly prohibited from listing, buying, or
          engaging in any transaction involving domains that infringe upon
          trademarks, copyrights, or other intellectual property protections.
          <br />
          If you believe your intellectual property rights have been violated,
          please notify us immediately. Upon receiving a valid claim, we will
          investigate and take appropriate actions, which may include the
          removal of infringing listings, reversal of ownership, and suspension
          of responsible accounts.
        </p>

        <h1 className="heading">Compliance and Enforcement</h1>
        <div className="line-div4 "></div>
        <p className="paragraph pb-[15px]">
          The <strong>.gold Marketplace</strong> reserves the right to take
          necessary action in cases of policy violation, misuse, or fraudulent
          activity. These actions may include temporary restrictions,
          suspension, or permanent termination of access.
          <br />
          Continued use of our platform indicates your acknowledgment and
          acceptance of these terms. We encourage responsible engagement to
          ensure that <strong>.gold</strong> remains a secure, ethical, and
          value-driven marketplace for premium domain ownership.
        </p>
      </div>
    </div>
  );
}

export default TermsConditions;
